import './App.scss';
import Header from '../Tools/Header/Header';
import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import Notification from '../Tools/Notification/Notification';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Main from './Main';
import axios from 'axios';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [CitiesData, setCitiesData] = useState({});
  const location = useLocation()
  const url = new URL(window.location.href);

  const [BestWeightLoss, setBestWeightLoss] = useState([
    // SkinnyRx
    {
      "Active": true,
      "Provider": "SkinnyRx",
      "Logo": require(`../Images/SkinnyRx_logo.png`),
      "Attributes": [
        {
          "attribute": "Obesity medication delivered overnight — 100% online doctor visits and prescriptions"
        },
        {
          "attribute": "Access Ozempic®, Wegovy®, Zepbound®, and compounded Semaglutide & Tirzepatide"
        },
        {
          "attribute": "All medications filled by licensed U.S. pharmacies — free overnight shipping nationwide"
        },
        {
          "attribute": "Average member weight loss of 29.3 lbs in 6 months (self-reported) with 98% success rate"
        },
        {
          "attribute": "Flexible payment plans — Buy Now, Pay Later options available"
        }
      ],
      "Score": {
        "TitleDemand": "Popular Choice",
        "TitleSecDemand": "Trusted by 100,000+ Members Nationwide",
        "Rating": "EXCELLENT",
        "RatingCount": 10,
        "TimesVoted": 155700,
        "Review": "I lost over 35 lbs in just under 5 months with SkinnyRx! The program fit my busy lifestyle and the overnight shipping made everything so easy. Highly recommend to anyone serious about real results."
      },
      "Promostion": "Up to 43% Off GLP-1 Weight Loss Plans – Free Overnight Shipping",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1464&aff_id=10386" // Replace with actual affiliate or tracking link
    },
    // Remedy Meds
    {
      "Active": true,
      "Provider": "Remedy Meds",
      "Logo": require(`../Images/RemedyMeds_logo.png`),
      "Attributes": [
        {
          "attribute": "Ranked #1 by Forbes for GLP-1 weight loss treatments — over 300,000 lbs lost by patients"
        },
        {
          "attribute": "Get $100 off your first month (Code: NEWYOU2025) — no insurance, no waitlists, no hidden fees"
        },
        {
          "attribute": "Offers compounded Semaglutide and Tirzepatide from U.S.-licensed pharmacies"
        },
        {
          "attribute": "Flat monthly pricing includes provider access, medication, supplies, and shipping"
        }
      ],
      "Score": {
        "TitleDemand": "Top Rated",
        "TitleSecDemand": "Ranked #1 by Forbes for Weight Loss",
        "Rating": "EXCELLENT",
        "RatingCount": 9.9,
        "TimesVoted": 150000,
        "Review": "Remedy Meds helped me lose over 40 lbs in 5 months! The support was incredible and the process was so simple. Highly recommend it to anyone ready for real change."
      },
      "Promostion": "$120 Off Your First Month - Use Code: WEBMD",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1363&aff_id=10386" // Replace with actual tracking link
    },
    // Eden
    {
      "Active": true,
      "Provider": "Eden",
      "Logo": require(`../Images/Eden_Logo.png`),
      "Attributes": [
        {
          "attribute": "Access to FDA-approved GLP-1 medications including Ozempic®, Wegovy®, Zepbound®, and Mounjaro®"
        },
        {
          "attribute": "Flat-rate pricing-same cost regardless of dosage with no hidden fees or membership charges"
        },
        {
          "attribute": "Includes free virtual consultation, prescription, and ongoing medical support"
        },
        {
          "attribute": "Transparent, all-inclusive plans-compounded and FDA-approved medications available"
        },
      ],
      "Score": {
        "TitleDemand": "Most Flexible",
        "TitleSecDemand": "Trusted GLP-1 Access with No Surprises",
        "Rating": "Outstanding",
        "RatingCount": 9.9,
        "TimesVoted": 6633,
        "Review": "Eden helped me finally lose the weight and break old habits. No gimmicks-just real support, real results, and real change!"
      },
      "Promostion": "Start today-$100 off your first month + free expedited shipping",
      // Katalys
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1435&aff_id=10386&url_id=11486"
      // CJ
      // "AffiliateLink": "https://www.tkqlhce.com/click-101505546-17115346"
    },
    // MEDVi
    {
      "Active": true,
      "Provider": "MEDVi",
      "Logo": require(`../Images/MEDVi_Logo.png`),
      "Attributes": [
        {
          "attribute": "Fast, hassle-free start with same-day shipping-no insurance required"
        },
        {
          "attribute": "Unlimited doctor consults and personalized care coaching at no extra cost"
        },
        {
          "attribute": "Simple online signup-no appointments, no waiting rooms"
        }
      ],
      "Score": {
        "TitleDemand": "Most Popular",
        "TitleSecDemand": "Top Rated. Trusted by Emetya.",
        "Rating": "EXCELLENT",
        "RatingCount": 9.9,
        "TimesVoted": 12774,
        "Review": "MEDVi made everything so easy-fast shipping, great support, and real results. I feel healthier, more confident, and supported every step of the way. Highly recommend!"
      },
      "Promostion": "Save $120 + Free Shipping with MEDVi",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1265&aff_id=10386"
    },
    // Clinic Secret
    {
      "Active": true,
      "Provider": "Clinic Secret",
      "Logo": require(`../Images/ClinicSecret_Logo.png`),
      "Attributes": [
        {
          "attribute": "Get $50 off your first month with code: 50OFF"
        },
        {
          "attribute": "No insurance needed. No membership fees. No waitlist."
        },
        {
          "attribute": "Medication shipped from certified U.S. pharmacies — GLP-1 in stock"
        },
        {
          "attribute": "Weight loss guarantee: Reach your goal or your money back"
        }
      ],
      "Score": {
        "TitleDemand": "Weight Loss Guarantee: Lose It or It's Free",
        "TitleSecDemand": "Over 10,000+ Members. 4.7 Stars.",
        "Rating": "EXCELLENT",
        "RatingCount": 9.7,
        "TimesVoted": 10000,
        "Review": "Clinic Secret helped me drop 45 lbs with zero hassle. Their service is fast, legit, and I felt supported the whole time. Truly life-changing!"
      },
      "Promostion": "$50 off first month · Prescription GLP-1s from $199 · No insurance required",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1272&aff_id=10386" // Replace with actual tracking link
    },
    // FuturHealth
    {
      "Active": false,
      "Provider": "Futur Health",
      "Logo": require(`../Images/FuturHealth_Logo.png`),
      "Attributes": [
        {
          "attribute": "Access to GLP-1 meds like Ozempic®, Wegovy®, Zepbound®, Mounjaro®-prescribed based on BMI and profile"
        },
        {
          "attribute": "Clinician consultation, telehealth, and personalized nutrition plans included in subscription"
        },
        {
          "attribute": "Lose up to 20% of your body weight-92% of users report long-term results"
        },
        {
          "attribute": "Satisfaction guarantee-if you don’t lose weight with full adherence, get your membership fees back"
        }
      ],
      "Score": {
        "TitleDemand": "Popular Pick",
        "TitleSecDemand": "Doctor-Led + Nutrition Support",
        "Rating": "Outstanding",
        "RatingCount": 9.7,
        "TimesVoted": 5824,
        "Review": "FuturHealth helped me lose 30 lbs in under 6 months with their expert plan and GLP-1 support. Highly recommend!"
      },
      "Promostion": "Take the 3-minute quiz to get doctor-approved GLP-1 meds and lose up to 20% of your weight-no insurance needed",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1362&aff_id=10386"
    },
    // Prime Health
    {
      "Active": true,
      "Provider": "Prime Health",
      "Logo": require(`../Images/PrimeHealth_Logo.png`),
      "Attributes": [
        {
          "attribute": "Guaranteed 10% weight loss in 4 months-or your money back"
        },
        {
          "attribute": "No insurance needed-flat daily rate of $9.99 with no hidden fees or waitlists"
        },
        {
          "attribute": "Unlimited telehealth access with licensed U.S. doctors-easy 2-minute quiz to qualify"
        },
        {
          "attribute": "Access to compounded GLP-1s from U.S. pharmacies-semaglutide and tirzepatide"
        }
      ],
      "Score": {
        "TitleDemand": "New & Growing",
        "TitleSecDemand": "Simple Daily Plan + Money-Back Guarantee",
        "Rating": "Very Good",
        "RatingCount": 9.4,
        "TimesVoted": 7943,
        "Review": "Prime Health made weight loss easy. I lost over 10% in 3 months and loved the support and simplicity of the plan!"
      },
      "Promostion": "Start today for just $9.99/day-lose 10% of your body weight in 4 months or get your money back",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1412&aff_id=10386" // Replace with your actual tracking URL
    },
    // Direct Meds
    {
      "Active": true,
      "Provider": "Direct Meds",
      "Logo": require(`../Images/Direct_Meds_Logo.png`),
      "Attributes": [
        {
          "attribute": "Lose 1–2 pounds per week with clinically proven treatments"
        },
        {
          "attribute": "Get Semaglutide or Tirzepatide-generic versions of Ozempic & Mounjaro"
        },
        {
          "attribute": "Telehealth visits and prescriptions included with every plan"
        },
        {
          "attribute": "Injections and oral options available-delivered in 1–2 days"
        }
      ],
      "Score": {
        "TitleDemand": "Most Popular",
        "TitleSecDemand": "Only the Top Performers",
        "Rating": "Very Good",
        "RatingCount": 9.4,
        "TimesVoted": 11133,
        "Review": "Direct Meds made the process so simple. Fast shipping, helpful staff, and real results. I feel healthier, supported, and in control. Highly recommend this service!"
      },
      "Promostion": "Get started with Semaglutide or Tirzepatide-limited-time savings + free shipping",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1304&aff_id=10386"
    },
    // Sesame
    {
      "Active": true,
      "Provider": "Sesame",
      "Logo": require(`../Images/SESAME_Logo.png`),
      "Attributes": [
        {
          "attribute": "Weight loss medication and care starting at $99/month-video visits included"
        },
        {
          "attribute": "Choose your own board-certified provider for personalized care"
        },
        {
          "attribute": "GLP-1 medications available-including Ozempic®, Wegovy®, Zepbound®"
        },
        {
          "attribute": "Insurance accepted or affordable self-pay options available"
        },
      ],
      "Score": {
        "TitleDemand": "Best Value",
        "TitleSecDemand": "Affordable, Insurance-Friendly & Patient-Backed",
        "Rating": "Outstanding",
        "RatingCount": 9.2,
        "TimesVoted": 8423,
        "Review": "Sesame made my weight loss journey simple and affordable. I got to choose my doctor, everything was handled online, and I saw real results within months. Highly recommended!"
      },
      "Promostion": "Start for just $99/month-insurance accepted for GLP-1 medications",
      "AffiliateLink": "https://afflat3c1.com/trk/lnk/331783EC-1ED9-4E95-9B77-9F0BC2439611/?o=27300&c=918273&a=769132&k=A25C54D0DCB983F0BF3AA11ECBF82332&l=29393"
    },
    // Sprout Health
    {
      "Active": true,
      "Provider": "Sprout Health",
      "Logo": require(`../Images/Sprout_Logo.png`),
      "Attributes": [
        {
          "attribute": "Get Semaglutide or Tirzepatide prescribed in under 24 hours-no insurance required"
        },
        {
          "attribute": "Clinically proven GLP-1 medications with average weight loss of 24.9 lbs"
        },
        {
          "attribute": "Flat pricing: $249/mo for Semaglutide, $299/mo for Tirzepatide-no hidden fees"
        },
        {
          "attribute": "Free shipping, ongoing doctor support, and $50 off your first month with code FIRST50"
        }
      ],
      "Score": {
        "TitleDemand": "Fastest GLP-1 Access",
        "TitleSecDemand": "Join 5M+ Americans Seeing Real Results",
        "Rating": "Outstanding",
        "RatingCount": 9.1,
        "TimesVoted": 19632,
        "Review": "Sprout changed everything. I finally lost the weight I struggled with for years. Fast approval, easy process, and I feel incredible every day."
      },
      "Promostion": "Use code FIRST50 to get $50 off your first month-Semaglutide for $199 or Tirzepatide for $249",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1286&aff_id=10386"
    },
    // Delilah Health
    {
      "Active": true,
      "Provider": "Delilah Health",
      "Gender": "Woman",
      "Logo": require(`../Images/Delilah_Logo.jpeg`),
      "Attributes": [
        {
          "attribute": "GLP-1 weight loss treatments tailored specifically for women with ambitious lifestyles"
        },
        {
          "attribute": "Includes free health coaching, lab work, and no hidden fees with all-in pricing"
        },
        {
          "attribute": "Licensed providers create custom plans based on your health, goals, and daily routine"
        },
        {
          "attribute": "6-month money-back guarantee if you're not satisfied with results"
        }
      ],
      "Score": {
        "TitleDemand": "Top Pick",
        "TitleSecDemand": "Proven. Trusted. Recommended.",
        "Rating": "Outstanding",
        "RatingCount": 8.9,
        "TimesVoted": 7730,
        "Review": "Delilah helped me take control of my health. I lost 25 lbs in 3 months and feel stronger, more energized, and empowered. Highly recommend for women!"
      },
      "Promostion": "Take the 2-minute quiz to get pre-approved for a personalized GLP-1 treatment-now with free labs & coaching",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1331&aff_id=10386"
    },
    // Fella Health
    {
      "Active": true,
      "Provider": "Fella Health",
      "Gender": "Men",
      "Logo": require(`../Images/FellaHealth_Logo.png`),
      "Attributes": [
        {
          "attribute": "GLP-1 weight loss treatments designed specifically for men with busy lifestyles"
        },
        {
          "attribute": "Includes personalized assessments, doctor-prescribed plans, and guaranteed medication delivery"
        },
        {
          "attribute": "Real results-members have lost 20 to 74 lbs with ongoing support and coaching"
        },
        {
          "attribute": "Money-back guarantee if you're not satisfied with your results"
        }
      ],
      "Score": {
        "TitleDemand": "Built for Men",
        "TitleSecDemand": "Highest Rated & Emetya Approved",
        "Rating": "EXCELLENT",
        "RatingCount": 8.9,
        "TimesVoted": 11672,
        "Review": "Fella changed my life. I’ve lost over 40 pounds, feel more confident, and finally found a plan that fits my lifestyle and keeps me accountable."
      },
      "Promostion": "Take the free 2-min quiz and get instant pre-approval for your weight loss plan",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1330&aff_id=10386"
    },
    // UrWay Health - false
    {
      "Active": false,
      "Provider": "UrWay Health",
      "Logo": require(`../Images/UrWay_Health_Log.png`),
      "Attributes": [
        {
          "attribute": "Personalized GLP-1 weight loss plans-includes medication, dosing, and virtual care"
        },
        {
          "attribute": "Telehealth consultations with licensed providers-no clinics, no insurance required"
        },
        {
          "attribute": "Custom programs for weight loss, anti-aging, sexual health, and wellness"
        },
        {
          "attribute": "Fast shipping within 24–48 hours and ongoing clinical support included"
        }
      ],
      "Score": {
        "TitleDemand": "Fastest Access",
        "TitleSecDemand": "Your Most Reliable Choices",
        "Rating": "Very Good",
        "RatingCount": 8.9,
        "TimesVoted": 10463,
        "Review": "UrWay Health gave me real results with a plan built just for me. Easy telehealth, fast delivery, and total support. I finally feel in control!"
      },
      "Promostion": "Get started today with GLP-1s-$50 off your first plan with code SAVE50",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1411&aff_id=10386&url_id=11312"
    },
    // ReflexMD - false
    {
      "Active": false,
      "Provider": "ReflexMD",
      "Logo": require(`../Images/Reflexmd_Logo.png`),
      "Attributes": [
        {
          "attribute": "GLP-1 treatments for weight management-no hidden fees or insurance required"
        },
        {
          "attribute": "Access licensed physicians 24/7 with expert support from wellness advisors"
        },
        {
          "attribute": "Over 75,000 patients trust ReflexMD’s telehealth platform for personalized care"
        },
        {
          "attribute": "Free expedited and discreet shipping included with every prescription"
        }
      ],
      "Score": {
        "TitleDemand": "Fastest Access",
        "TitleSecDemand": "Expert Approved & Highly Rated",
        "Rating": "Very Good",
        "RatingCount": 8.8,
        "TimesVoted": 10463,
        "Review": "ReflexMD made getting started so simple. I had 24/7 access to doctors, fast shipping, and great support. I’m already seeing results. Highly recommended!"
      },
      "Promostion": "Free express shipping + 24/7 doctor access with every GLP-1 plan",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=682&aff_id=10386"
    },
    // Strut Health - false
    {
      "Active": false,
      "Provider": "Strut Health",
      "Logo": require(`../Images/StrutHealth_Logo.png`),
      "Attributes": [
        {
          "attribute": "Oral Semaglutide available-GLP-1 weight loss treatment in easy-to-take format"
        },
        {
          "attribute": "Includes provider consultation and medication-no hidden fees or insurance needed"
        },
        {
          "attribute": "U.S.-licensed doctors review each case online within 1 business day-no video visit required"
        },
        {
          "attribute": "Prepared in board-certified U.S. pharmacies and delivered discreetly in 2 days"
        }
      ],
      "Score": {
        "TitleDemand": "Most Popular",
        "TitleSecDemand": "Trusted. Tested. Top Rated.",
        "Rating": "Good",
        "RatingCount": 8.6,
        "TimesVoted": 10463,
        "Review": "My experience with Strut Health was seamless. The process was fast, the care team was responsive, and the results were real. I’d absolutely use them again."
      },
      "Promostion": "Now offering oral Semaglutide-fast approval, free shipping, and discreet delivery",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=384&aff_id=10386&url_id=8345"
    },
    // Brightmeds - false
    {
      "Active": false,
      "Provider": "Brightmeds",
      "Logo": require(`../Images/Brightmeds_Logo.png`),
      "Attributes": [
        {
          "attribute": "Sermorelin injections to boost natural HGH production-personalized telehealth-based care"
        },
        {
          "attribute": "Includes medical consultation, 1-month medication supply, and all injection supplies"
        },
        {
          "attribute": "Board-certified U.S. physicians-HIPAA-compliant telemedicine with ongoing support"
        },
        {
          "attribute": "Free expedited shipping-FSA/HSA eligible-money-back guarantee if not approved"
        }
      ],
      "Score": {
        "TitleDemand": "Top HGH Support",
        "TitleSecDemand": "Safe, Effective Hormone Peptide Therapy",
        "Rating": "Good",
        "RatingCount": 8.5,
        "TimesVoted": 552,
        "Review": "Brightmeds made the whole process simple. Great service, responsive team, and noticeable results within weeks. Highly recommended!"
      },
      "Promostion": "Save $50 on your first Sermorelin order-1-month supply starts at $105",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=1396&aff_id=10386"
    },
    // Henry Meds - false
    {
      "Active": false,
      "Provider": "Henry Meds",
      "Logo": require(`../Images/HenryMeds_Logo.png`),
      "Attributes": [
        {
          "attribute": "Compounded GLP-1 treatments from U.S.-licensed pharmacies, including semaglutide, tirzepatide, liraglutide, and phentermine"
        },
        {
          "attribute": "Flat monthly pricing-as low as $99 for the first month with no hidden fees, insurance, or waitlists"
        },
        {
          "attribute": "Includes medication, supplies, free shipping, and unlimited telehealth visits with licensed U.S. providers"
        },
        {
          "attribute": "Choose between injections, oral tablets, or drops-personalized for your needs"
        }
      ],
      "Score": {
        "TitleDemand": "Up to $100 Off First Month",
        "TitleSecDemand": "Compounded GLP-1s-Oral & Injectable Options",
        "Rating": "Good",
        "RatingCount": 8.4,
        "TimesVoted": 7320,
        "Review": "Henry Meds made everything so easy! I’m down 18 pounds and love that I could choose oral or injection based on my lifestyle."
      },
      "Promostion": "Start your plan for as low as $99/month-includes medication, provider visits, and shipping",
      "AffiliateLink": "https://track.revoffers.com/aff_c?offer_id=694&aff_id=10386&url_id=8344"
    },
    // Elevate Health
{
  "Active": false,
  "Provider": "Elevate Health",
  "Logo": require(`../Images/ElevateHealth_logo.png`),
  "Attributes": [
    {
      "attribute": "Get started for as little as $0 down — no insurance required"
    },
    {
      "attribute": "Medication included — no membership or hidden fees"
    },
    {
      "attribute": "Home-delivered, compounded GLP-1 medication from licensed U.S. pharmacies"
    },
    {
      "attribute": "Fast, discreet shipping with full provider support"
    },
    {
      "attribute": "Flexible payments with Affirm, Afterpay, and HSA/FSA options"
    }
  ],
  "Score": {
    "TitleDemand": "Trusted Choice",
    "TitleSecDemand": "Affordable $0 Down GLP-1 Program",
    "Rating": "EXCELLENT",
    "RatingCount": 8,
    "TimesVoted": 124800,
    "Review": "Elevate Health made the entire process simple and stress-free. I started at $0 down and lost 22 lbs in 12 weeks. Their support team was amazing, and delivery was super fast. Couldn’t be happier!"
  },
  "Promostion": "Start For $0 Down — Medication Included & No Insurance Needed",
  "AffiliateLink": "https://www.elevatehealth.com/?ref=emetly" // Replace with actual tracking link
}
  ]);

  useEffect(() => {
    (async () => {
      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

    })();
  }, []);

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>
      {/* Menu */}
      {showMenu ? <Menu setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {/* {location.pathname.match("/request-service") ? null : <Header showMenu={showMenu} setShowMenu={setShowMenu} />} */}
      {/* Main App */}
      <Main BestWeightLoss={BestWeightLoss} CitiesData={CitiesData} />
      {/* Footer */}
      {/* {location.pathname.match("/request-service") ? null : <Footer Companies={Companies} WebSitePages={WebSitePages} />} */}

    </div>
  );
}

export default App;
